// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-content {
    min-width: 400px;
    padding: 10px 0;
}

.form-label {
    font-weight: 500;
    margin-bottom: 0.5rem;
    display: block;
}

.text-danger {
    color: #dc3545;
}

.alert {
    padding: 12px;
    border-radius: 4px;
    display: flex;
    align-items: center;
}

.alert-info {
    background-color: #d1ecf1;
    border: 1px solid #bee5eb;
    color: #0c5460;
}

.alert-danger {
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    color: #721c24;
}

.align-middle {
    vertical-align: middle;
}

.mr-2 {
    margin-right: 0.5rem;
}

.mb-3 {
    margin-bottom: 1rem;
}

.mt-3 {
    margin-top: 1rem;
}

.mt-2 {
    margin-top: 0.5rem;
}

.d-inline-block {
    display: inline-block;
}

.text-center {
    text-align: center;
}

.text-muted {
    color: #6c757d;
}

.success-icon {
    font-size: 48px;
    width: 48px;
    height: 48px;
    color: #28a745;
}

.queue-info {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.queue-position-badge {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #e3f2fd;
    border: 2px solid #1976d2;
    border-radius: 12px;
    padding: 16px 32px;
    min-width: 120px;
}

.position-number {
    font-size: 32px;
    font-weight: 700;
    color: #1976d2;
    line-height: 1;
}

.position-label {
    font-size: 14px;
    color: #1976d2;
    margin-top: 4px;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.pat-expiry-fields {
    -moz-column-gap: 8px;
         column-gap: 8px;
    row-gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/shared/start-assessment-dialog/start-assessment-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,oBAAe;SAAf,eAAe;IACf,YAAY;AAChB","sourcesContent":[".dialog-content {\n    min-width: 400px;\n    padding: 10px 0;\n}\n\n.form-label {\n    font-weight: 500;\n    margin-bottom: 0.5rem;\n    display: block;\n}\n\n.text-danger {\n    color: #dc3545;\n}\n\n.alert {\n    padding: 12px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n}\n\n.alert-info {\n    background-color: #d1ecf1;\n    border: 1px solid #bee5eb;\n    color: #0c5460;\n}\n\n.alert-danger {\n    background-color: #f8d7da;\n    border: 1px solid #f5c6cb;\n    color: #721c24;\n}\n\n.align-middle {\n    vertical-align: middle;\n}\n\n.mr-2 {\n    margin-right: 0.5rem;\n}\n\n.mb-3 {\n    margin-bottom: 1rem;\n}\n\n.mt-3 {\n    margin-top: 1rem;\n}\n\n.mt-2 {\n    margin-top: 0.5rem;\n}\n\n.d-inline-block {\n    display: inline-block;\n}\n\n.text-center {\n    text-align: center;\n}\n\n.text-muted {\n    color: #6c757d;\n}\n\n.success-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    color: #28a745;\n}\n\n.queue-info {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.queue-position-badge {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background: #e3f2fd;\n    border: 2px solid #1976d2;\n    border-radius: 12px;\n    padding: 16px 32px;\n    min-width: 120px;\n}\n\n.position-number {\n    font-size: 32px;\n    font-weight: 700;\n    color: #1976d2;\n    line-height: 1;\n}\n\n.position-label {\n    font-size: 14px;\n    color: #1976d2;\n    margin-top: 4px;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n.pat-expiry-fields {\n    column-gap: 8px;\n    row-gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
